import UbiModal from './UbiModal';

export default UbiModal;
